import React from 'react';
import styled from 'styled-components';
import bg from "../../Assets/bgs/bg-tick.jpeg"

const Style = styled.div`
    border: 1px solid var(--n-grey-2);
    /* width: 50%; */
    /* float: inline-start; */
    min-width: 0;
    margin: 1rem 0;
    padding: 0.7rem;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    position: relative;
    overflow: hidden;
    .backgroung {
        position: absolute;
        inset: -2.5%;
        display: block;
        object-fit: cover;
        width: 105%;
        height: 105%;
        z-index: -1;
        filter: blur(5px);
    }
    .top {
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
    }
    .rooms {
        display: flex;
        align-items: center;
        gap: 0.3rem;
        .room {
            display: flex;
            padding: 0.5rem;
            gap: 0.2rem;
            border: 1px solid var(--n-grey-2);
            border-radius: 0.3rem;
            background-color: #fff;
            box-shadow: 0 5px 10px -2px #00000055;
        }
    }
    @media screen and (max-width: 850px) {
        .top {
            flex-direction: column;
        }
        .rooms {
            .room {
                flex-direction: column;
            }
        }
    }
`

const TourField = (props) => {
    const data = props.textFields;
    const makeRooms = () => {
        const rooms = data.rooms
        return rooms.map((v, i) => {
            return (
                <div className='room' key={i}>
                    <div className='title'>
                        {v.title}:
                    </div>
                    <div className='price'>
                        {v.price}
                    </div>
                </div>
            )
        })
    }
    return (
        <Style className='text-block'>
            <img className='backgroung' src={bg} alt='backgroung'/>
            <div className='top'>
                <div className='title'>
                    {data.package}: {data.dateStart} {localStorage.getItem('lang') === "en" ? "to" : "الی"}  {data.dateEnd}
                </div>
                <div className='date'>
                    {data.title}
                </div>
            </div>
            <div className=''>
                {data.details}
            </div>
            <div className='rooms'>
                <div className='heading-room'>
                    {localStorage.getItem('lang') === "en" ? "Prices:" : "نرخ ها:"} 
                </div>
                {makeRooms()}
            </div>
        </Style>
    )
}
export default TourField;